import cn from 'classnames';
import {
  Children,
  cloneElement,
  isValidElement,
  type MemoExoticComponent,
  memo,
  type ReactNode,
} from 'react';

import { VARIANTS } from './constants';
import { StepperItem, type StepperItemProps } from './item/StepperItem';
import * as styles from './Stepper.styles';

export type StepperProps = {
  variant?: VARIANTS;
  children?: ReactNode | ReactNode[];
};

export const StepperBase = ({
  variant = VARIANTS.VERTICAL,
  children = undefined,
}: StepperProps) => {
  const childrenArray = Children.toArray(children).filter(isValidElement<StepperItemProps>);

  return (
    <div css={styles.container} className={variant}>
      {childrenArray.map((child, index) => (
        <div
          key={JSON.stringify(child.props.href) || index}
          css={styles.step}
          className={cn({ variant, isLast: child.props.isLast, isHidden: child.props.isHidden })}
        >
          {cloneElement(child, {
            index: index + 1,
            variant,
            isLast: index === childrenArray.length - 1,
          })}
        </div>
      ))}
    </div>
  );
};

StepperBase.displayName = 'Stepper';

export const Stepper: MemoExoticComponent<typeof StepperBase> & {
  Step?: typeof StepperItem;
  VARIANTS?: typeof VARIANTS;
} = memo(StepperBase);

Stepper.Step = StepperItem;
Stepper.VARIANTS = VARIANTS;
